import React from "react";
import { Table, TableHead, TableRow, TableCell, TableBody, Tooltip, Checkbox } from "@material-ui/core";
import { ButtonIcon } from "@loanbossinc/component-library";
import { ButtonsGroup } from "components/ButtonsGroup";
import styled from "styled-components";

import { LRD_ROLE, LrdRoleType, LrdCheckType } from "../../../constants";

const roleOptions = [
  { name: LRD_ROLE[LrdRoleType.ADMIN], index: 0, value: LrdRoleType.ADMIN },
  { name: LRD_ROLE[LrdRoleType.USER], index: 1, value: LrdRoleType.USER }
];

const StyledTableHeadRow = styled(TableRow)`&&& {
    background-color: #EDE9E9;
    border-top: 1px solid #DADCE0;
    border-bottom: 1px solid #DADCE0;
    > th {
        font-family: Work Sans;
        font-size: 12px;
        font-weight: 500;
        line-height: 14px;
        color: #000000;
        text-transform: uppercase;
        text-align: center;
        padding: 0;
    }
}`;

const WideCell = styled(TableCell)`&&& {
    width: calc(100% / 6 * 2);
    text-align: left !important;
    padding-left: 2em !important;
}`;

const NormalCell = styled(TableCell)`&&& {
    width: calc(100% / 6);
    white-space: pre-wrap;
}`;

const CellTextWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 4px;
`;

const CellTextApproveReportWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 4px;
    justify-content: center;
    margin-right: 30px;
    text-align: center;
`;

const NameBodyCell = styled(TableCell)`&&& {
    font-family: Work Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 19px;
}`;

const StyledTableBodyRow = styled(TableRow)`&&& {
    > td {
        padding: 1em 2em;
    }
}`;

const UsersTable = ({ permissionedUsersState, handleCheck, handleDeleteRow, handleRoleSelection }) => (
  <Table>
    <TableHead>
      <StyledTableHeadRow>
        <WideCell>User</WideCell>
        <NormalCell>
          <CellTextWrapper>
            <div>Role</div>
          </CellTextWrapper>
        </NormalCell>
        <NormalCell>
          <CellTextApproveReportWrapper>
            <div>Approve Reports</div>
          </CellTextApproveReportWrapper>
        </NormalCell>
        <NormalCell>
          <CellTextWrapper>
            <div>Privileged Information</div>
            <Tooltip
              placement="right-end"
              title="Users with this permission can view tasks marked as privileged."
            >
              <ButtonIcon iconName="error_outline" />
            </Tooltip>
          </CellTextWrapper>
        </NormalCell>
        <NormalCell />
      </StyledTableHeadRow>
    </TableHead>
    <TableBody>
      {
                permissionedUsersState?.map(({ id, contact, lenderReportingRoleTypeId, isApprover, isPrivileged }) => {
                  const isAdmin = lenderReportingRoleTypeId === LrdRoleType.ADMIN;

                  return (
                    <StyledTableBodyRow key={id}>
                      <NameBodyCell>{contact?.name ? contact?.name : `${contact?.firstName} ${contact?.lastName}`}</NameBodyCell>
                      <TableCell>
                        <ButtonsGroup
                          userId={id}
                          onChange={handleRoleSelection}
                          options={roleOptions}
                          selected={lenderReportingRoleTypeId}
                        />
                      </TableCell>
                      <TableCell>
                        <Checkbox
                          checked={isAdmin ? true : isApprover}
                          disabled={isAdmin}
                          onChange={() => handleCheck(LrdCheckType.APPROVER, id)}
                        />
                      </TableCell>
                      <TableCell>
                        <Checkbox
                          checked={isAdmin ? true : isPrivileged}
                          disabled={isAdmin}
                          onChange={() => handleCheck(LrdCheckType.PRIVILEGED, id)}
                        />
                      </TableCell>
                      <TableCell><ButtonIcon iconName="delete" style={{ color: "#C40A0A" }} onClick={() => handleDeleteRow(id)} /></TableCell>
                    </StyledTableBodyRow>
                  );
                })
      }
    </TableBody>
  </Table>
);

export default UsersTable;
